export default "__VITE_ASSET__BwQXLpfb__"